export const IMAGE_SIZE = 316;
